import { setSessionStorageItem } from './sessionStorage'

// List below was created with use of https://www.netify.ai/resources/applications

const SOURCE_DOMAINS = [
  {
    label: 'Facebook',
    links: [
      'accountkit.com',
      'acebook.com',
      'faacebook.com',
      'facebbook.com',
      'facebook-dns.com',
      'facebook-hardware.com',
      'facebook.co',
      'facebook.com',
      'facebook.com.au',
      'facebook.com.mx',
      'facebook.it',
      'facebook.net',
      'facebookcareers.com',
      'facebookenterprise.com',
      'facebookmail.com',
      'facebookrecruiting.com',
      'facebookstudy.com',
      'facebookvirtualassistant.com',
      'fb.audio',
      'fb.com',
      'fb.gg',
      'fb.me',
      'fb.watch',
      'fbcdn.net',
      'fbe2e.com',
      'fbinfra.net',
      'fbpigeon.com',
      'fbsbx.com',
      'fbthirdpartypixel.com',
      'fbwat.ch',
      'internet.org',
      'm-freeway.com',
      'parse.com',
      'wit.ai',
    ],
  },
  {
    label: 'Instagram',
    links: ['cdninstagram.com', 'ig.me', 'instagram.com'],
  },
  {
    label: 'LinkedIn',
    links: [
      'bizographics.com',
      'cs1404.wpc.epsiloncdn.net',
      'cs767.wpc.epsiloncdn.net',
      'l-0005.dc-msedge.net',
      'l-0005.l-dc-msedge.net',
      'l-0005.l-msedge.net',
      'l-0015.l-msedge.net',
      'licdn.cn',
      'licdn.com',
      'linkedin.at',
      'linkedin.cn',
      'linkedin.com',
      'lnkd.in',
    ],
  },
  {
    label: 'Pintrest',
    links: [
      '2-01-37d2-0018.cdx.cedexis.net',
      'akapinimg.net',
      'pin.it',
      'pinimg.com',
      'pinterest.at',
      'pinterest.ca',
      'pinterest.ch',
      'pinterest.cl',
      'pinterest.co.kr',
      'pinterest.co.uk',
      'pinterest.com',
      'pinterest.com.au',
      'pinterest.com.mx',
      'pinterest.de',
      'pinterest.dk',
      'pinterest.es',
      'pinterest.fr',
      'pinterest.ie',
      'pinterest.it',
      'pinterest.jp',
      'pinterest.net',
      'pinterest.nz',
      'pinterest.ph',
      'pinterest.pt',
      'pinterest.ru',
      'pinterest.se',
      'pinterestmail.com',
    ],
  },
  {
    label: 'Reddit',
    links: [
      'redd.it',
      'reddit.com',
      'redditblog.com',
      'redditinc.com',
      'redditmail.com',
      'redditmedia.com',
      'redditstatic.com',
      'redditstatus.com',
    ],
  },
  {
    label: 'Tiktok',
    links: [
      'abtest-sg-tiktok.byteoversea.com',
      'abtest-va-tiktok.byteoversea.com',
      'gts.byteoversea.net',
      'isnssdk.com',
      'lf1-ttcdn-tos.pstatp.com',
      'muscdn.com',
      'musemuse.cn',
      'musical.ly',
      'p1-tt-ipv6.byteimg.com',
      'p1-tt.byteimg.com',
      'p16-ad-sg.ibyteimg.com',
      'p16-tiktok-sg.ibyteimg.com',
      'p16-tiktok-sign-va-h2.ibyteimg.com',
      'p16-tiktok-va-h2.ibyteimg.com',
      'p16-tiktok-va.ibyteimg.com',
      'p16-va-tiktok.ibyteimg.com',
      'p26-tt.byteimg.com',
      'p3-tt-ipv6.byteimg.com',
      'p9-tt.byteimg.com',
      'pull-f3-hs.pstatp.com',
      'pull-f5-hs.flive.pstatp.com',
      'pull-f5-hs.pstatp.com',
      'pull-f5-mus.pstatp.com',
      'pull-flv-f1-hs.pstatp.com',
      'pull-flv-f6-hs.pstatp.com',
      'pull-flv-l1-hs.pstatp.com',
      'pull-flv-l1-mus.pstatp.com',
      'pull-flv-l6-hs.pstatp.com',
      'pull-hls-l1-mus.pstatp.com',
      'pull-l3-hs.pstatp.com',
      'pull-rtmp-f1-hs.pstatp.com',
      'pull-rtmp-f6-hs.pstatp.com',
      'pull-rtmp-l1-hs.pstatp.com',
      'pull-rtmp-l1-mus.pstatp.com',
      'pull-rtmp-l6-hs.pstatp.com',
      'quic-tiktok-core-proxy-i18n-gcpva.byteoversea.net',
      'quic-tiktok-proxy-i18n-gcpva.byteoversea.net',
      'sf1-ttcdn-tos.pstatp.com',
      'sf16-ttcdn-tos.ipstatp.com',
      'sf6-ttcdn-tos.pstatp.com',
      'sgsnssdk.com',
      'tiktok-lb-alisg.byteoversea.net',
      'tiktok-lb-maliva.byteoversea.net',
      'tiktok-platform-lb-alisg.byteoversea.net',
      'tiktok.com',
      'tiktokcdn-in.com',
      'tiktokcdn-us.com',
      'tiktokcdn.com',
      'tiktokcdn.com.atomile.com',
      'tiktokcdn.com.c.bytetcdn.com',
      'tiktokcdn.com.c.worldfcdn.com',
      'tiktokcdn.com.rocket-cdn.com',
      'tiktokd.org',
      'tiktokv.com',
      'tiktokv.com.c.worldfcdn2.com',
      'tlivecdn.com',
      'ttlivecdn.com',
      'ttlivecdn.com.c.worldfcdn.com',
      'ttoversea.net',
    ],
  },
  {
    label: 'Twitter',
    links: [
      'ads-twitter.com',
      'periscope.tv',
      'pscp.tv',
      't.co',
      'tweetdeck.com',
      'twimg.com',
      'twitpic.com',
      'twitter.co',
      'twitter.com',
      'twitterinc.com',
      'twitteroauth.com',
      'twitterstat.us',
      'twttr.com',
    ],
  },
  {
    label: 'GitHub',
    links: [
      'ghcr.io',
      'github.com',
      'github.com.herokudns.com',
      'github.community',
      'github.io',
      'githubapp.com',
      'githubassets.com',
      'githubusercontent.com',
    ],
  },
  {
    label: 'YouTube',
    links: [
      'googlevideo.com',
      'gvt1.com',
      'video.google.com',
      'youtu.be',
      'youtube-nocookie.com',
      'youtube-ui.l.google.com',
      'youtube.ae',
      'youtube.al',
      'youtube.am',
      'youtube.at',
      'youtube.az',
      'youtube.ba',
      'youtube.be',
      'youtube.bg',
      'youtube.bh',
      'youtube.bo',
      'youtube.by',
      'youtube.ca',
      'youtube.cat',
      'youtube.ch',
      'youtube.cl',
      'youtube.co',
      'youtube.co.ae',
      'youtube.co.at',
      'youtube.co.cr',
      'youtube.co.hu',
      'youtube.co.id',
      'youtube.co.il',
      'youtube.co.in',
      'youtube.co.jp',
      'youtube.co.ke',
      'youtube.co.kr',
      'youtube.co.ma',
      'youtube.co.nz',
      'youtube.co.th',
      'youtube.co.tz',
      'youtube.co.ug',
      'youtube.co.uk',
      'youtube.co.ve',
      'youtube.co.za',
      'youtube.co.zw',
      'youtube.com',
      'youtube.com.ar',
      'youtube.com.au',
      'youtube.com.az',
      'youtube.com.bd',
      'youtube.com.bh',
      'youtube.com.bo',
      'youtube.com.br',
      'youtube.com.by',
      'youtube.com.co',
      'youtube.com.do',
      'youtube.com.ec',
      'youtube.com.ee',
      'youtube.com.eg',
      'youtube.com.es',
      'youtube.com.gh',
      'youtube.com.gr',
      'youtube.com.gt',
      'youtube.com.hk',
      'youtube.com.hn',
      'youtube.com.hr',
      'youtube.com.jm',
      'youtube.com.jo',
      'youtube.com.kw',
      'youtube.com.lb',
      'youtube.com.lv',
      'youtube.com.ly',
      'youtube.com.mk',
      'youtube.com.mt',
      'youtube.com.mx',
      'youtube.com.my',
      'youtube.com.ng',
      'youtube.com.ni',
      'youtube.com.om',
      'youtube.com.pa',
      'youtube.com.pe',
      'youtube.com.ph',
      'youtube.com.pk',
      'youtube.com.pt',
      'youtube.com.py',
      'youtube.com.qa',
      'youtube.com.ro',
      'youtube.com.sa',
      'youtube.com.sg',
      'youtube.com.sv',
      'youtube.com.tn',
      'youtube.com.tr',
      'youtube.com.tw',
      'youtube.com.ua',
      'youtube.com.uy',
      'youtube.com.ve',
      'youtube.cr',
      'youtube.cz',
      'youtube.de',
      'youtube.dk',
      'youtube.ee',
      'youtube.es',
      'youtube.fi',
      'youtube.fr',
      'youtube.ge',
      'youtube.googleapis.com',
      'youtube.gr',
      'youtube.gt',
      'youtube.hk',
      'youtube.hr',
      'youtube.hu',
      'youtube.ie',
      'youtube.in',
      'youtube.iq',
      'youtube.is',
      'youtube.it',
      'youtube.jo',
      'youtube.jp',
      'youtube.kr',
      'youtube.kz',
      'youtube.la',
      'youtube.lk',
      'youtube.lt',
      'youtube.lu',
      'youtube.lv',
      'youtube.ly',
      'youtube.ma',
      'youtube.md',
      'youtube.me',
      'youtube.mk',
      'youtube.mn',
      'youtube.mx',
      'youtube.my',
      'youtube.ng',
      'youtube.ni',
      'youtube.nl',
      'youtube.no',
      'youtube.pa',
      'youtube.pe',
      'youtube.ph',
      'youtube.pk',
      'youtube.pl',
      'youtube.pr',
      'youtube.pt',
      'youtube.qa',
      'youtube.ro',
      'youtube.rs',
      'youtube.ru',
      'youtube.sa',
      'youtube.se',
      'youtube.sg',
      'youtube.si',
      'youtube.sk',
      'youtube.sn',
      'youtube.soy',
      'youtube.sv',
      'youtube.tn',
      'youtube.tv',
      'youtube.ua',
      'youtube.ug',
      'youtube.uy',
      'youtube.vn',
      'youtubeeducation.com',
      'youtubeembeddedplayer.googleapis.com',
      'youtubei.googleapis.com',
      'youtubekids.com',
      'yt.be',
      'yt3.ggpht.com',
      'ytimg.com',
    ],
  },
  {
    label: 'Vimeo',
    links: ['vhx.com', 'vhx.tv', 'vimeo.com', 'vimeocdn.com'],
  },
]

const checkSocialDomains = () => {
  const docReferrer =
    typeof document !== 'undefined' && document.referrer && new URL(document.referrer)

  if (docReferrer && docReferrer.hostname) {
    const match = SOURCE_DOMAINS.find(item => {
      return item.links.find(link => {
        const domainPartsReversed = docReferrer.hostname.split('.').reverse()
        const sldAndFld = `${domainPartsReversed[1]}.${domainPartsReversed[0]}`
        return link === sldAndFld
      })
    })

    if (match) {
      const utm_medium = 'Organic'
      const utm_source = 'Social'
      const utm_campaign = match.label
      setSessionStorageItem('utm_medium', utm_medium)
      setSessionStorageItem('utm_source', utm_source)
      setSessionStorageItem('utm_campaign', utm_campaign)
      return { utm_campaign, utm_medium, utm_source }
    }
  }
  return {}
}

export default checkSocialDomains
